// parts
export const SET_SHOW_PART = 'SET_SHOW_PART';
export const SET_SHOWHELPER_PART = 'SET_SHOWHELPER_PART';
// groups
export const SET_SHOW_GROUP = 'SET_SHOW_GROUP';
export const SET_SHOWTOOLTIP_GROUP = 'SET_SHOWTOOLTIP_GROUP';
// questions
export const SET_SHOWHELPER_QUESTION = 'SET_SHOWHELPER_QUESTION';
export const SET_SHOWVALUE_QUESTIONS = 'SET_SHOWVALUE_QUESTIONS';
export const SET_VALUE_QUESTION = 'SET_VALUE_QUESTION';

//
export const SET_CODE_FIRST_ERROR = 'SET_CODE_FIRST_ERROR';
export const UPDATE = 'UPDATE';
